<template>
  <div class="d-flex justify-content-between align-items-center">
    <span>{{ $t('general.dark-mode') }}</span>
    <b-form-checkbox
      :checked="isDark"
      class="custom-control-primary ml-1"
      name="check-button"
      switch
      @change="skin = isDark ? 'light' : 'dark'"
    />
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { BFormCheckbox } from 'bootstrap-vue'
import { computed } from '@vue/composition-api/dist/vue-composition-api'

export default {
  components: {
    BFormCheckbox,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}
</script>
